//定义工具类
const util = {};
//json2formData
util.json2formData = function(jsonData) {
  const params = new URLSearchParams();
    for (const key in jsonData) {
      //遍历json对象的每个key/value对
      params.append(key, jsonData[key]);
    }
    return params;
}

util.check = function(str, s) {
  const start = str.indexOf(s);
  const n = str.indexOf(s, start + 1);
  if (n > 0) {
      return true;
  }
  return false;
}

export default util;